import { VolumeAllocationErrorCodes } from '../../models/volume-allocation';
import { ActionTypes, Actions } from '../actions/volume-allocation.action';

export interface VolumeAllocation {
  message: string;
  invalid: boolean;
  loading?: boolean;
  code?: string;
}

export const initialState: VolumeAllocation = {
  message: '',
  invalid: false,
  code: '',
  loading: false,
};

export function reducer(state = initialState, action: Actions): VolumeAllocation {
  switch (action.type) {
    case ActionTypes.SET_VOLUME_MANAGEMENT_SUCCESS: {
      let volumeState = action.payload;
      if (!action.payload.invalid) {
        const invalid = VolumeAllocationErrorCodes.some(errorCode => action.payload.code === errorCode);
        volumeState = { ...action.payload, invalid: invalid, loading: false };
      }
      return volumeState;
    }

    case ActionTypes.RESET_VOLUME_MANAGEMENT: {
      return {
        message: '',
        invalid: false,
        loading: false,
        code: '',
      };
    }

    case ActionTypes.LOADING_VOLUME_MANAGEMENT: {
      return {
        ...state,
        loading: true,
      };
    }

    case ActionTypes.SET_VOLUME_MANAGEMENT: {
      return {
        ...state,
        loading: true,
      };
    }

    default:
      return state;
  }
}
